import React from "react";
import moment from "moment";

import withStyles from "@material-ui/core/styles/withStyles";
import Chip from "@material-ui/core/Chip";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";

import {DATE_FORMAT} from "../../../../../../../utils/constants";

import styles from "./styles";

const ExpireBadge = ({classes, expiredAt}) => (
  <Grid item>
    <div className={classes.expiredChipContainer}>
      <Chip
        label={
          <>
            <Box component={'span'} display={{ xs: 'none', sm: 'inline' }}>abgelaufen am </Box>
            {moment(expiredAt).format(DATE_FORMAT)}
          </>
        }
        className={classes.expiredChip}
        size={'small'}
      />
    </div>
  </Grid>
);

export default withStyles(styles)(ExpireBadge);